import { render, staticRenderFns } from "./NewComplaint.vue?vue&type=template&id=48f614a5"
import script from "./NewComplaint.vue?vue&type=script&lang=js"
export * from "./NewComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports